/**
 * Generated from LoadScreenLayout.fla
 */
export function LoadScreenLayout(this: ILoadScreenLayout) {
	const bg = this.bg;
	LoadScreenLayout_bg.call(this.bg);
	bg.x = 512;
	bg.y = 384;
	bg.width = 1664.00;
	bg.height = 768.00;
	if (bg.onLayout) bg.onLayout();
	const loaderBase = this.loaderBase;
	LoadScreenLayout_loaderBase.call(this.loaderBase);
	loaderBase.x = 512;
	loaderBase.y = 384;
	loaderBase.width = 145.00;
	loaderBase.height = 145.00;
	if (loaderBase.onLayout) loaderBase.onLayout();
	const loaderSpinner = this.loaderSpinner;
	LoadScreenLayout_loaderSpinner.call(this.loaderSpinner);
	loaderSpinner.x = 512;
	loaderSpinner.y = 384;
	loaderSpinner.width = 136.00;
	loaderSpinner.height = 136.00;
	if (loaderSpinner.onLayout) loaderSpinner.onLayout();
	return this;
}
function LoadScreenLayout_bg(this: ILoadScreenLayout_bg) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-splashscreen-bg@2x.jpg", 0.500, 0.500);
	return this;
}
function LoadScreenLayout_loaderBase(this: ILoadScreenLayout_loaderBase) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-loader-base.png", 0.500, 0.500);
	return this;
}
function LoadScreenLayout_loaderSpinner(this: ILoadScreenLayout_loaderSpinner) {
	if (this.setLayoutTexture) this.setLayoutTexture("cyberchase-loader-spinner.png", 0.500, 0.500);
	return this;
}
interface ILoadScreenLayoutArray<T> {
	[index: number]: T;
	elementFactory?(index:number, parameters?:any): T;
}
interface ILoadScreenLayoutContainer {
	x?: number;
	y?: number;
	scale?: {x:number, y:number};
	rotation?: number;
	width?: number;
	height?: number;
	onLayout?(): void;
}
interface ILoadScreenLayoutSprite extends ILoadScreenLayoutContainer {
	setLayoutTexture?(name: string, anchorX :number, anchorY :number): void;
}
interface ILoadScreenLayoutText extends ILoadScreenLayoutContainer {
	fontSize: number;
	textAreaWidth: number;
	textAreaHeight: number;
}
interface ILoadScreenLayoutPolygon extends Array<number> {
}
interface ILoadScreenLayout {
	readonly bg: ILoadScreenLayout_bg;
	readonly loaderBase: ILoadScreenLayout_loaderBase;
	readonly loaderSpinner: ILoadScreenLayout_loaderSpinner;
}
interface ILoadScreenLayout_bg extends ILoadScreenLayoutSprite {
}
interface ILoadScreenLayout_loaderBase extends ILoadScreenLayoutSprite {
}
interface ILoadScreenLayout_loaderSpinner extends ILoadScreenLayoutSprite {
}
